import GlicthReportsTable from '@/app/reportDetail'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { glitchReportsQueryOptions } from '@/hooks/useGlitchReportsQuery'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <GlicthReportsTable />
}

export const Route = createFileRoute('/_auth/_withProject/reportDetail')({
  beforeLoad: ({ context }) => {
    if (
      ability &&
      context.auth.user &&
      !ability.can('read', 'Olumsuzluk Bildirimi')
    ) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient, auth } = context
    if (!auth?.user?.id) return {}
    await queryClient.prefetchQuery(
      glitchReportsQueryOptions(auth?.user?.id as number | string),
    )
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})
